/**
 * Emmera — Scroll Animations
 * Intersection Observer based, no dependencies
 */
(function () {
  'use strict';

  // ── Fade-up observer ─────────────────────────────
  const observerOpts = {
    threshold: 0.12,
    rootMargin: '0px 0px -60px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = el.dataset.delay || 0;
        setTimeout(() => {
          el.classList.add('is-visible');
        }, parseInt(delay));
        observer.unobserve(el);
      }
    });
  }, observerOpts);

  function initAnimations() {
    document.querySelectorAll('[data-anim]').forEach(el => {
      observer.observe(el);
    });
  }

  // ── Number counter ───────────────────────────────
  function animateCounter(el) {
    const target = parseFloat(el.dataset.count.replace(/[^0-9.]/g, ''));
    const suffix = el.dataset.count.replace(/[0-9.,\s]/g, '');
    const duration = 1800;
    const start = performance.now();

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * target);
      el.textContent = current.toLocaleString('fr-CH') + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.dataset.counted) {
        entry.target.dataset.counted = 'true';
        animateCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  function initCounters() {
    document.querySelectorAll('[data-count]').forEach(el => {
      counterObserver.observe(el);
    });
  }

  // ── Marquee pause on hover ───────────────────────
  function initMarquee() {
    document.querySelectorAll('.emmera-marquee').forEach(el => {
      el.addEventListener('mouseenter', () => el.style.animationPlayState = 'paused');
      el.addEventListener('mouseleave', () => el.style.animationPlayState = 'running');
    });
  }

  // ── Init ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAnimations();
      initCounters();
      initMarquee();
    });
  } else {
    initAnimations();
    initCounters();
    initMarquee();
  }
})();
